import React from 'react';
import { IconButton, PrimaryButton, DefaultButton, classNamesFunction } from '@fluentui/react';
var getClassNames = classNamesFunction();
export var CoherencePanelFooterBase = function (props) {
    var showRenderFooter = props.showRenderFooter, hasCloseButton = props.hasCloseButton, closeButtonAriaLabel = props.closeButtonAriaLabel, theme = props.theme, styles = props.styles, onDismiss = props.onDismiss, onRenderFooter = props.onRenderFooter;
    var classNames = getClassNames(styles, { theme: theme });
    var accessibleCloseButton = !hasCloseButton && (React.createElement(IconButton, { iconProps: { iconName: 'Cancel' }, className: classNames.accessibleCloseButton, id: "accessible_close_button", "aria-label": closeButtonAriaLabel !== null && closeButtonAriaLabel !== void 0 ? closeButtonAriaLabel : 'Close', onClick: function (e) {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(e);
        } }));
    var _renderButtons = function () {
        var _a = onRenderFooter, _b = _a.primaryButton, primaryButton = _b === void 0 ? {} : _b, _c = _a.secondaryButton, secondaryButton = _c === void 0 ? {} : _c;
        var hasPrimarySet = (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text) && (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.onAction);
        var hasSecondarySet = (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text) && (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.onAction);
        return (React.createElement(React.Fragment, null,
            hasPrimarySet && (React.createElement(PrimaryButton, { disabled: !!primaryButton.disabled, onClick: primaryButton.onAction }, primaryButton.text)),
            hasSecondarySet && (React.createElement(DefaultButton, { disabled: !!secondaryButton.disabled, onClick: secondaryButton.onAction }, secondaryButton.text))));
    };
    if (!showRenderFooter)
        return null;
    if (typeof onRenderFooter === 'function') {
        return (React.createElement("div", { className: classNames.root },
            onRenderFooter(),
            accessibleCloseButton));
    }
    else {
        return (React.createElement("div", { className: classNames.root },
            _renderButtons(),
            accessibleCloseButton));
    }
};
//# sourceMappingURL=CoherencePanelFooter.base.js.map